import React from "react";

const TableHeader = () => {
  return (
    <thead className="text-xs">
      <tr>
        <th
          rowspan="2"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          DATE
        </th>
        <th
          rowspan="2"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          NUMBER OF TRANSFER
        </th>
        <th
          colspan="3"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          TRANSFERORS
        </th>
        <th
          colspan="3"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          TRANSFEREES
        </th>
        <th
          colspan="2"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          NUMBER OF SHARES TRANSFERRED
        </th>
        <th
          colspan="2"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          DISTINCTIVE NUMBER OF SHARES TRANSFERRED
        </th>
        <th
          rowspan="2"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          TRANSFER VALUE
        </th>
        <th
          rowspan="2"
          scope="col"
          className="font-semibold text-gray-900 bg-gray-100"
        >
          SHARE CERT NO
        </th>
      </tr>
      <tr>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          FOLIO IN REGISTER OF MEMBERS
        </th>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          NAME
        </th>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          ADDRESS
        </th>

        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          NAME
        </th>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          ADDRESS
        </th>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          FOLIO IN REGISTER OF MEMBERS
        </th>

        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          ORD
        </th>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          PREF
        </th>

        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          FROM
        </th>
        <th scope="col" className="font-semibold text-gray-900 bg-gray-100">
          TO
        </th>
      </tr>
    </thead>
  );
};

export default TableHeader;
